import React from 'react';
import OnboardingConsent from './onboarding_consent'

export {OnboardingConsent}